<template>
  <v-row class="ma-4">
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="30"></v-progress-circular>
    </v-overlay>
    <v-col cols="12" sm="6">
      <v-date-picker
        class="border"
        ref="picker"
        locale="vi"
        v-model="date"
        :picker-date.sync="pickerDate"
        :events="arrayEvents"
        color="#0D47A1"
        full-width
        event-color="red"
      ></v-date-picker>
    </v-col>
    <v-col v-if="date !== null" cols="12" sm="6" class="pl-4">
      <div class="text-h6">{{ formatDateTimeTable(date) }}</div>
      <div class="ml-2 mt-2">
        <div v-if="!currentDateEvent.length">Không có lịch vào ngày này</div>
        <div v-else v-for="lesson in currentDateEvent" :key="lesson.id" class="subheading">
          <div>{{ lesson.startTime }} - {{ lesson.gradeTitle }} - {{ lesson.classTitle }}</div>
          <div v-for="t in lesson.teachers" :key="t.id">
            <a :href="`/teacher/${t.id}`" target="_blank" style="text-decoration: none">{{ t.name || '' }}</a>
          </div>
          <div v-if="lesson.classroom">
            (Phòng {{ lesson.classroom.name }}, Toà {{ lesson.classroom.building }}, Tầng {{ lesson.classroom.floor }})
          </div>
          <v-divider class="my-2"></v-divider>
          <div class="d-flex align-items-center">
            <SubstituteTeachingManager :lesson="lesson" @update:lesson="fetchLessonsForMonth" />
            <DeleteLesson :lesson="lesson" @delete="fetchLessonsForMonth" />
          </div>
        </div>
      </div>
    </v-col>
    <v-col v-else cols="12" sm="6" class="d-flex justify-center align-center">
      <div class="text-h6">Vui lòng chọn ngày để xem chi tiết</div>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import SubstituteTeachingManager from './SubstituteTeachingManager.vue'
import DeleteLesson from './DeleteLesson.vue'
export default {
  components: {
    SubstituteTeachingManager,
    DeleteLesson,
  },
  props: {
    classData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      date: null,
      arrayEvents: [],
      dateEvents: {},
      currentDateEvent: [],
      pickerDate: null,
      start: null,
      end: null,
      loading: false,
    }
  },
  computed: {
    ...mapState('lesson', ['lessons']),
  },
  methods: {
    ...mapActions('lesson', ['fetchLessons']),
    groupByDate(arr) {
      return arr.reduce((groups, item) => {
        const dateKey = moment(item.date).format('YYYY-MM-DD')
        if (!groups[dateKey]) {
          groups[dateKey] = []
        }
        groups[dateKey].push(item)
        return groups
      }, {})
    },
    getFirstAndLastDayOfMonth(yearMonth) {
      const date = moment(yearMonth, 'YYYY-MM')
      this.start = date.startOf('month').toISOString()
      this.end = date.endOf('month').toISOString()
    },
    formatDateTimeTable(date) {
      moment.locale('vi')
      return moment(date)
        .format('dddd, DD/MM/YYYY')
        .replace(/^./, (str) => str.toUpperCase())
    },
    async fetchLessonsForMonth() {
      if (this.classData.id) {
        this.loading = true
        try {
          await this.fetchLessons({ class: this.classData.id, date_gte: this.start, date_lte: this.end })
        } finally {
          this.loading = false
        }
      }
    },
  },
  watch: {
    lessons: {
      handler(value) {
        if (!value.length) {
          this.dateEvents = {}
          this.arrayEvents = []
          return
        }
        this.dateEvents = this.groupByDate(value)
        this.arrayEvents = Object.keys(this.dateEvents)
        this.currentDateEvent = this.dateEvents[this.date] || []
      },
      immediate: true,
      deep: true,
    },
    date(value) {
      this.currentDateEvent = this.dateEvents[value] || []
    },
    pickerDate(value) {
      this.getFirstAndLastDayOfMonth(value)
      this.fetchLessonsForMonth()
    },
    classData: {
      handler() {
        this.fetchLessonsForMonth()
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>
<style scoped>
.border {
  border: 1px solid #e0e0e0;
}
</style>
